import Alert from '@/components/Alert';
import { ButtonPrimary, InputText, ButtonSocmed, ButtonOutline } from '@/components/Form';
import { Edit, Headset } from '@/components/Icon';
import { Body, Paragraph, Text } from '@/components/Typography';
import { Spacer, Box, Divider, AbsoluteCenter, Flex, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel, useDisclosure } from '@chakra-ui/react';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { DIContainer } from "../../../packages/idn-media-framework-tsyringe/DIContainer";
import { IEventBus } from "../../../packages/idn-media-framework-abstraction/IEventBus";
import { ILogger } from "../../../packages/idn-media-framework-abstraction/ILogger";
import Layout from 'layouts/V2';
import { FC, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { identitySchema, type IdentityFormData } from './validations';
import Modal from '@/components/Modal';
import ModalHeader from '@/components/Modal/ModalHeader';
import { colors } from '@/styles/theme/constants';
import Button from '@/components/Button';
import { CompositionRoot } from 'src/CompositionRoot';
import checkForceAuth from '@/components/helpers/checkForceAuth';
import { API, Auth, I18n } from 'aws-amplify';
import { OAuthFlow } from '@/components/helpers/OAuthFlow';
import { getOnboardingToggle } from '@/utility/onboarding';
import { useRouter } from 'next/router';
import { IAuthenticationService } from '@/packages/idn-media-framework-abstraction/IAuthenticationService';
import { CustomErrors } from '@/constants/customErrorStrings';
import { getIdentityType, userIdenityType } from '@/utility/identityType';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { UserIdenityType, formatPhoneNumber } from '@/utility/identity';
import { useOTPStore } from '../../Verification/V2/useOTPStore';
import LoadingPage from '@/components/LoadingPage';
import { IEventBusSubcription } from '@/packages/idn-media-framework-abstraction/IEventBusSubcription';
import Image from "next/image";
import Link from "next/link";
import { GetPageLink } from '@/utility/getLinkPage';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { extractAuthSession } from '@/utility/amplify';
import { checkDeviceLimit, checkDeviceLimitFromStorage } from '@/containers/DeviceLimitPopup/checkDeviceLimit';
import DeviceLimitPopup from '@/containers/DeviceLimitPopup';

const accordionContent = [
  {
    title: "Pengumpulan Data Pribadi",
    content: (
      <>
        Kami mengumpulkan data pribadi saat Anda membuat akun IDN Connect,
        termasuk namun tidak terbatas pada:
        <ol style={{ marginLeft: "1rem", marginTop: "0.5rem" }}>
          <li>1. Nama lengkap</li>
          <li>2. Alamat email</li>
          <li>3. Nomor telepon</li>
          <li>4. Tanggal lahir</li>
          <li>5. Data aktivitas Anda dalam ekosistem IDN</li>
        </ol>
        <p style={{ marginTop: "0.75rem" }}>
          Dengan membuat akun, Anda menyatakan bahwa data yang Anda berikan
          adalah benar dan milik pribadi, bukan milik orang lain. Penggunaan
          identitas palsu atau milik pihak lain tanpa izin melanggar kebijakan
          kami dan dapat dikenakan sanksi
        </p>
      </>
    ),
  },
  {
    title: "Penggunaan Data untuk Promosi dan Marketing",
    content: (
      <>
        Dengan menggunakan layanan IDN Connect, Anda menyetujui bahwa data
        diri dan aktivitas Anda akan dicatat dan digunakan untuk:
        <ol style={{ marginLeft: "1rem", marginTop: "0.5rem" }}>
          <li>
            1. Mengirimkan informasi promosi, penawaran khusus, atau berita
            terbaru seputar produk dan layanan IDN
          </li>
          <li>
            2. Memberikan konten dan rekomendasi yang dipersonalisasi sesuai
            minat Anda
          </li>
          <li>
            3. Melakukan analisis perilaku pengguna untuk meningkatkan
            kualitas layanan
          </li>
          <li>
            4. Kami tidak akan menjual data pribadi Anda kepada pihak ketiga.
            Data hanya akan digunakan untuk kebutuhan internal dan afiliasi
            terpercaya kami yang mendukung layanan IDN Connect.
          </li>
        </ol>
      </>
    ),
  },
  {
    title: "Hak Pengguna",
    content: (
      <>
        Anda memiliki hak untuk:
        <ol style={{ marginLeft: "1rem", marginTop: "0.5rem" }}>
          <li>
            1. Mengakses dan memperbarui data pribadi Anda kapan saja melalui
            halaman akun
          </li>
          <li>
            2. Menarik persetujuan Anda terkait penggunaan data untuk promosi
            (opt-out) melalui pengaturan akun atau tautan berhenti
            berlangganan
          </li>
          <li>
            3. Menghapus akun dan seluruh data pribadi Anda dari sistem kami,
            sesuai prosedur yang berlaku
          </li>
        </ol>
      </>
    ),
  },
  {
    title: "Keamanan dan Penyimpanan Data",
    content: (
      <>
        Kami menerapkan langkah-langkah teknis dan organisasi untuk melindungi
        data Anda dari akses yang tidak sah, perubahan, atau penyalahgunaan.
        Data Anda akan disimpan selama akun Anda aktif atau selama dibutuhkan
        untuk tujuan yang dijelaskan dalam Kebijakan Privasi ini.
      </>
    ),
  },
  {
    title: "Perubahan Kebijakan Privasi",
    content: (
      <>
        Kebijakan ini dapat diperbarui dari waktu ke waktu untuk mencerminkan
        perubahan pada praktik kami atau peraturan yang berlaku. Kami akan
        memberitahu Anda melalui email atau notifikasi pada aplikasi jika
        terdapat perubahan signifikan.
      </>
    ),
  },
];

const handleIdPLogin = (identity_provider: any) => {
  const logger = DIContainer.Resolve<ILogger>("ILogger");
  let queryStringParams = new URLSearchParams(window.location.search);
  let redirect_uri = queryStringParams.get("redirect_uri");
  let authorization_code = queryStringParams.get("authorization_code");
  let clientState = queryStringParams.get("state");

  if (redirect_uri) {
    logger.debug("Storing redirect_uri to storage:", redirect_uri);
    localStorage.setItem(`client-redirect-uri`, redirect_uri);
  }
  if (authorization_code) {
    logger.debug("Storing authorization_code to storage:", authorization_code);
    localStorage.setItem(`authorization_code`, authorization_code);
  }
  if (clientState) {
    logger.debug("Storing clientState to storage:", clientState);
    localStorage.setItem(`client-state`, clientState);
  }

  localStorage.setItem(`social_identity_provider`, identity_provider);
  Auth.federatedSignIn({ provider: identity_provider });
};

const HomePage: FC = () => {
  const setCognitoUser = useOTPStore((s) => s.setCognitoUser);
  const [alertMessageSocmed, setAlertMessageSocmed] = useState<string>("");
  const { isOpen, onClose, onOpen } = useDisclosure();
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [isLoadingPage, setIsLoadingPage] = useState<boolean>(true);
  const router = useRouter();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [identity, setIdentity] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { isOpen: isOpenBanned, onClose: onCloseBanned, onOpen: onOpenBanned } = useDisclosure();
  const [isDeviceLimitReached, setIsDeviceLimitReached] = useState(false);
  const [deviceLimitCount, setDeviceLimitCount] = useState(0);

  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleIdpRelogin = async () => {
    setIsLoadingPage(true);

    const identity_provider = localStorage.getItem("social_identity_provider");
    const validProviders = [
      CognitoHostedUIIdentityProvider.Google,
      CognitoHostedUIIdentityProvider.Facebook,
      CognitoHostedUIIdentityProvider.Apple
    ];

    if (identity_provider && validProviders.includes(identity_provider as CognitoHostedUIIdentityProvider)) {
      await Auth.federatedSignIn({ provider: identity_provider as CognitoHostedUIIdentityProvider });
    } else {
      setIsLoadingPage(false);
    }
  };

  const handleIdpSignIn = async (providerName: any) => {
    const logger = DIContainer.Resolve<ILogger>("ILogger");
    logger.debug("SocialLoginButton clickHandler called");

    const eventBus = DIContainer.Resolve<IEventBus>("IEventBus");
    eventBus.Dispatch("HomePage", {
      eventName: "SocialLoginButtonClicked",
      data: providerName,
      message: "",
    });
  };

  const fetchToggle = async (): Promise<{ toggle: string }> => {
    const url = `${process.env.NEXT_PUBLIC_CDN_URL}/idn-connect/config/save-tokens-toggle.json`;

    const response = await fetch(url, {
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Failed to fetch cdn save-tokens-toggle.json');
    }

    return response.json();
  };

  useEffect(() => {
    if (router.query.error_description) {
      const errorDesc = router.query.error_description.toString().trim();

      const standardErrors = [
        CustomErrors.DISABLE_EMAIL_PERMISSION_FACEBOOK,
        CustomErrors.DISABLE_EMAIL_PERMISSION_FACEBOOK_PRESIGNUP_TRIGGER,
        CustomErrors.USER_ALREADY_DELETED,
        CustomErrors.USER_ALREADY_DELETED_REGISTER_IDNACCOUNT,
        CustomErrors.USER_ALREADY_DELETED_SIGNIN_IDNACCOUNT
      ];

      if (standardErrors.includes(errorDesc)) {
        setAlertMessageSocmed(I18n.get(errorDesc));
      } else if (errorDesc === CustomErrors.USER_ALREADY_EXIST_REGISTER_IDNACCOUNT) {
        const isPhoneNumber = getIdentityType(identity) === userIdenityType.PHONE_NUMBER;
        const errorKey = isPhoneNumber
          ? CustomErrors.PHONE_NUMBER_ALREADY_EXIST_REGISTER
          : CustomErrors.EMAIL_ALREADY_EXIST_REGISTER;
        setAlertMessageSocmed(I18n.get(errorKey));
      } else if (/password.reset.required.for.the.user/gi.test(errorDesc)) {
        setAlertMessageSocmed(CustomErrors.SOCMED_SIGNIN_RESET_REQUIRED);
      } else if (
        errorDesc == CustomErrors.ACCESS_DENIED_FACEBOOK ||
        errorDesc == CustomErrors.CANCELLED_AUTHORIZE_APPLE ||
        /already.found.an.entry.for.username/gi.test(errorDesc)
      ) {
        return;
      } else if (errorDesc.includes("kamu melebihi batas device")) {
        setAlertMessageSocmed("Akun Anda telah mencapai batas maksimum login. Keluar dari perangkat lain untuk melanjutkan.");
      } else if (errorDesc.includes("user already banned")) {
        setIsLoadingPage(false);
        onOpenBanned();
      } else {
        setAlertMessageSocmed(CustomErrors.DEFAULT_MSG);
      }
    }
  }, [router.isReady, router.query.error, router.query.error_description]);

  useEffect(() => {
    let authenticationServiceSubscription: IEventBusSubcription | null = null;

    const init = async () => {
      if (isInitialized) {
        setIsLoadingPage(false);
      }

      await CompositionRoot.InitializeApplication();

      const eventBus = DIContainer.Resolve<IEventBus>("IEventBus");
      await eventBus.CreateTopic("HomePage");

      await checkForceAuth();

      const loginFormSubscription = eventBus.Subscribe("HomePage", async (e) => {
        if (e.eventName === "SocialLoginButtonClicked") {
          handleIdPLogin(e.data);
        }
      });

      authenticationServiceSubscription = await eventBus.Subscribe(
        "IAuthenticationService",
        async (e) => {
          if (e.eventName === "signIn") {
            const storageResult = await checkDeviceLimitFromStorage();
            if (storageResult?.blocked) {
              setIsDeviceLimitReached(true);
              setDeviceLimitCount(storageResult.deviceCount);
              setIsLoadingPage(false);
              return;
            }

            let toggle: string;

            try {
              const responseToggle = await fetchToggle();
              toggle = responseToggle.toggle;
            } catch (error) {
              toggle = 'off';
            }

            // Store amplify token to db
            if (e.data && toggle === 'on') {
              const user = e.data as CognitoUser;
              const session = extractAuthSession(user);

              try {
                await API.post("v1", "/auth/tokens", {
                  headers: {
                    Authorization: `Bearer ${session.accessToken}`,
                  },
                  body: {
                    refresh_token: session.refreshToken,
                    id_token: session.idToken,
                  }
                });
              } catch (err) {
                console.error("Failed saving token to db:", err);
              }
            }

            // setUser(e.data);

            try {
              setIsLoadingPage(true);

              const deviceLimitResult = await checkDeviceLimit();
              if (deviceLimitResult.blocked) {
                setIsDeviceLimitReached(true);
                setDeviceLimitCount(deviceLimitResult.deviceCount);
                setIsLoadingPage(false);
                return;
              }

              const OAuthFlowSignIn = await new OAuthFlow().handleSignIn();

              const extraReq = {
                headers: {
                  Authorization: `Bearer ${(await Auth.currentSession())
                    .getAccessToken()
                    .getJwtToken()}`,
                },
              };

              const response = await API.get("profile", "/detail", extraReq);

              const url = `/api/config/onboarding-toggle`;
              const config = await fetch(url)
                .then((response) => response.json())
                .catch((e) => console.log(e));

              const toggle = getOnboardingToggle(response.data, config);
              const needsOnboarding = response?.data?.is_onboarding === false && toggle === "on";

              if (OAuthFlowSignIn?.isOAuthFlow === false) {
                setIsLoadingPage(false);
                if (needsOnboarding && router.pathname !== "/onboarding") {
                  router.push('/onboarding');
                } else {
                  setIsLoggedIn(true);
                }
              } else if (OAuthFlowSignIn?.isOAuthFlow === true) {
                setIsLoadingPage(true);

                if (OAuthFlowSignIn.redirectUrl) {
                  if (needsOnboarding) {
                    const encodedUrl = encodeURIComponent(OAuthFlowSignIn.redirectUrl);
                    window.location.replace(`/onboarding?redirect=${encodedUrl}`);
                  } else {
                    window.location.replace(OAuthFlowSignIn.redirectUrl);
                  }
                }
              }
            } catch (error: any) {
              if (error.response?.data == "Invalid authorization_code") {
                setIsLoggedIn(true);
                setIsLoadingPage(false);
              }
            }
          } else if (e.eventName === "signOut") {
            setIsLoggedIn(false);
            // setUser(null);
            // setIsNewPasswordRequiredChallange(false);
          } else {
            setIsLoadingPage(false);
          }
        }
      );

      const authenticationService = DIContainer.Resolve<IAuthenticationService>("IAuthenticationService");
      await authenticationService.CheckLoggedIn();

      if (
        router.query.error_description &&
        /already.found.an.entry.for.username/gi.test(router.query.error_description.toString())
      ) {
        handleIdpRelogin();
      }
    };

    init();
    setIsInitialized(true);
    sessionStorage.removeItem('login_session');
    sessionStorage.removeItem('otp_session');

    return () => {
      if (authenticationServiceSubscription) {
        const eventBus = DIContainer.Resolve<IEventBus>("IEventBus");
        eventBus.Unsubscribe(authenticationServiceSubscription);
      }
    };
  }, []);

  const { register, handleSubmit, formState: { errors }, setValue, setFocus } = useForm({
    resolver: yupResolver(identitySchema)
  });

  useEffect(() => {
    if (router.isReady) {
      const username = sessionStorage.getItem('auth_username');
      if (username) {
        (setValue as any)('identity', (username), { shouldValidate: true });
        setTimeout(() => {
          setFocus('identity');
        }, 100);
      }
    }
  }, [router.isReady, router.query, setValue, setFocus]);

  const initiateOTPLogin = async (username: string) => {
    try {
      const user = await Auth.signIn(username);
      return user;
    } catch (error) {
      throw error;
    }
  };

  const requestOTP = async (user: any, identityType: string, recaptchaToken: string) => {
    try {
      const randomCode = Math.floor(100000 + Math.random() * 900000).toString();
      const result = await Auth.sendCustomChallengeAnswer(user, randomCode, {
        currentChallenge: 'LOGIN_TYPE_CHALLENGE',
        recaptchaToken: recaptchaToken,
        identityType: identityType
      });
      return result;
    } catch (error) {
      throw error;
    }
  };

  const onSubmit = async (data: any) => {
    const logger = DIContainer.Resolve<ILogger>('ILogger');
    logger.debug('[submitIdentity] - Starting submit identity');
    try {
      setIsSubmitting(true);
      setErrorMessage("");

      if (!executeRecaptcha) return;

      let username = data.identity;

      const identityType = getIdentityType(username);

      if (identityType === UserIdenityType.PHONE_NUMBER) {
        username = formatPhoneNumber(username);
      }

      logger.debug('[submitIdentity] - set username to session storage', username);
      sessionStorage.setItem('auth_username', username);

      logger.debug('[submitIdentity] - Generate token create user');
      const tokenCreateUser = await executeRecaptcha('createUserCognito_IndexPage');

      logger.debug('[submitIdentity] - init body');
      const requestBody = {
        user_identity: username,
        recaptcha_token: tokenCreateUser
      }

      logger.debug('[submitIdentity] - Request body: ', requestBody);

      const apiResponse = await fetch('/api/v1/user/cognito', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      });

      logger.debug('[submitIdentity] - Response status: ', apiResponse.status);

      if (apiResponse.ok) {
        const responseResult = await apiResponse.json();

        if (responseResult.data.is_new_user === true) {
          const user = await Auth.signIn(username);
          const randomCode = Math.floor(100000 + Math.random() * 900000).toString();
          const tokenLogin = await executeRecaptcha('requestOTP_IndexPage');
          const updatedUser = await Auth.sendCustomChallengeAnswer(user, randomCode, {
            currentChallenge: 'LOGIN_TYPE_CHALLENGE',
            recaptchaToken: tokenLogin,
            identityType: identityType
          });
          setCognitoUser(updatedUser);

          sessionStorage.setItem('otp_session', JSON.stringify({
            username: identity,
            identityType: identityType,
            is_newUser: true,
            updatedUser: updatedUser,
            uuid: responseResult.data.uuid,
          }));

          router.push(GetPageLink(`/otp`, router.query))
        } else if (responseResult.data.is_new_user === false) {
          // If Gmail email, use user_identity from API response instead of raw input
          if (username.toLowerCase().endsWith('@gmail.com') && responseResult.data.user_identity) {
            sessionStorage.setItem('auth_username', responseResult.data.user_identity);
          }

          sessionStorage.setItem('login_session', JSON.stringify({
            uuid: responseResult.data.uuid,
          }));
          router.push(GetPageLink(`/login`, router.query))
        }
      } else {
        const errorData = await apiResponse.json().catch(() => ({}));
        const errorMessage = errorData?.error?.message
          || errorData?.message
          || errorData?.error
          || `HTTP Error: ${apiResponse.status}`;

        throw new Error(errorMessage);
      }
    } catch (error: any) {
      console.error('Login error:', error);
      const msg = error.message || 'Terjadi kesalahan saat login';

      if (msg.includes("user already banned")) {
        onOpenBanned();
      } else {
        setErrorMessage(msg);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (isLoggedIn) router.push("/my-account");
  }, [isLoggedIn, router.push, router.asPath]);

  return (
    <>
      <DeviceLimitPopup
        isOpen={isDeviceLimitReached}
        deviceCount={deviceLimitCount}
      />
      {(isLoggedIn || isLoadingPage || isLoggedIn === undefined) && (
        <LoadingPage />
      )}
      {isLoggedIn === false && isLoadingPage === false && (
        <Layout>
          <Paragraph variant="Bold14" color="shade01" textAlign="center">
            Masuk atau Daftar Akun
          </Paragraph>
          <Spacer h="12px" />
          <form onSubmit={handleSubmit(onSubmit)}>
            {errorMessage && (
              <Box mb="16px">
                <Alert text={errorMessage} />
              </Box>
            )}
            <InputText
              label="Masukkan Email Atau Nomor HP"
              rightIcon={<Edit />}
              isRightIconDisabled
              errorMessage={errors.identity?.message}
              isDisabled={isSubmitting}
              {...register('identity')}
            />
            <Spacer h="24px" />
            <ButtonPrimary w="100%" type="submit" isLoading={isSubmitting} data-testid="buttonLogin_Lanjutkan">Lanjutkan</ButtonPrimary>
          </form>
          <Spacer h="12px" />
          <Body variant="Default14" color="shade03" textAlign="center">
            Dengan masuk, saya setuju dengan <Body onClick={onOpen} cursor="pointer" as="span" variant="Bold14" color="accent03">Syarat &  Ketentuan.</Body>
          </Body>
          <Box position="relative" my="24px">
            <Divider />
            <AbsoluteCenter bg="#F6F7F9" px="16px">
              <Text variant="othersStatus" color="shade05">
                ATAU
              </Text>
            </AbsoluteCenter>
          </Box>
          <Box data-testid="section_socmed_landingPage">
            {alertMessageSocmed && (
              <Box mb="16px" data-testid="alert_socmed_landingPage">
                <Alert text={alertMessageSocmed} />
              </Box>
            )}
            <Flex
              data-testid="grid_socmed_landingPage"
              alignItems="center"
              justifyContent="center"
              gap="8px"
            >
              <ButtonSocmed
                data-testid="button_socmed_apple"
                variant="apple"
                onClick={() =>
                  handleIdpSignIn(CognitoHostedUIIdentityProvider.Apple)
                }
              />
              <ButtonSocmed
                data-testid="button_socmed_facebook"
                variant="facebook"
                onClick={() =>
                  handleIdpSignIn(CognitoHostedUIIdentityProvider.Facebook)
                }
              />
              <ButtonSocmed
                data-testid="button_socmed_google"
                variant="google"
                onClick={() =>
                  handleIdpSignIn(CognitoHostedUIIdentityProvider.Google)
                }
              />
            </Flex>
          </Box>
          <Modal
            onClose={onClose}
            isOpen={isOpen}
            noMaxHeight={true}
            disabled={true}
            maxWidth={"400px"}
          >
            <ModalHeader showed={false} />
            <Body
              variant="Bold16"
              color="shade01"
              display={"flex"}
              alignItems={"center"}
              mb={4}
            >
              Kebijakan Privasi&nbsp;
              <Body
                onClick={onOpen}
                color={'red03'}
                variant="Bold12"
                fontSize={"md"}
              >
                IDN Connect
              </Body>
            </Body>
            <div
              data-testid="modal_successRegistration"
              className="mx-auto flex flex-col"
            >
              <Body variant="Default14" color="shade03">
                Terima kasih telah menggunakan layanan IDN Connect. Kami menghargai
                kepercayaan Anda dan berkomitmen untuk melindungi informasi pribadi
                Anda. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan,
                menggunakan, menyimpan, dan melindungi data pribadi Anda.
              </Body>
              <Accordion
                allowToggle
                border="1px solid #E5E9EC"
                borderRadius="16px"
                my={4}
                zIndex={999}
              >
                {accordionContent.map((item, index) => (
                  <AccordionItem
                    key={index}
                    bg="white"
                    boxShadow="sm"
                    border={"none"}
                    borderRadius={"16px"}
                  >
                    <h2>
                      <AccordionButton
                        py={4}
                        px={4}
                        _hover={{ bg: "none", boxShadow: "none" }}
                      >
                        <Box
                          as="span"
                          flex="1"
                          textAlign="left"
                          fontWeight="semibold"
                          fontSize="sm"
                        >
                          {item.title}
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel
                      pb={4}
                      px={4}
                      pt={0}
                      fontSize="sm"
                      color="gray.600"
                    >
                      {item.content}
                    </AccordionPanel>
                    <Divider color={"shade06"} />
                  </AccordionItem>
                ))}
              </Accordion>
              <Box bg={"shade08"} p={2} rounded={"8px"} mb={4}>
                <Flex alignItems={"start"} gap={2}>
                  <Box>
                    <Headset fill={colors.red03} />
                  </Box>
                  <Box>
                    <Body variant="SmallBold" color="shade02">
                      Kontak Kami
                    </Body>
                    <Body variant="Default14" color="shade03">
                      Jika Anda memiliki pertanyaan atau permintaan terkait data
                      pribadi Anda, silakan hubungi kami di:
                      <Body variant="Bold14" color="red03">
                        support@idn.media
                      </Body>
                    </Body>
                  </Box>
                </Flex>
              </Box>
              <Button
                data-testid="button_linkToIndex"
                text={"Saya Mengerti"}
                onClick={onClose}
                width="full-width"
              />
            </div>
          </Modal>
          <Modal
            onClose={onCloseBanned}
            isOpen={isOpenBanned}
            noMaxHeight={true}
            disabled={true}
            maxWidth={"327px"}
            hasCloseButton={false}
          >
            <ModalHeader showed={false} />
            <Flex alignItems={"center"} justifyContent={"center"} mx={"auto"}>
              <Image
                width={263}
                height={148}
                alt=""
                src="/assets/images/onboarding/account-already-banned.svg"
              />
            </Flex>
            <Body
              variant="Bold16"
              color="shade01"
              display={"flex"}
              alignItems={"center"}
              my={4}
            >
              Akunmu Telah Diblokir
            </Body>
            <Box
              data-testid="modal_successRegistration"
              className="mx-auto flex flex-col"
            >
              <Box mb={6}>
                <Body variant="Default14" color="shade03">
                  Akun ini tidak dapat digunakan lagi karena melakukan pelanggaran:
                </Body>
                <Body
                  variant="Default14"
                  color="shade03"
                  style={{ marginLeft: "1rem" }}
                >
                  <li>Menyiarkan ulang konten IDN Live.</li>
                  <li>Kirim komentar negatif berulang kali.</li>
                  <li>Kirim gambar/chat berisi SARA.</li>
                </Body>
                <Body variant="Default14" color="shade03">
                  Silakan baca penjelasan lengkapnya di bawah ini.
                </Body>
              </Box>
              <Link
                href="/my-account/user-guide#account-banned"
                target="_blank"
                rel="noopener noreferrer"
                style={{ width: "100%" }}
              >
                <ButtonPrimary
                  data-testid="buttonRedirect_PrivacyPolicy"
                  width="100%"
                  mb="8px"
                >
                  Lihat Selengkapnya
                </ButtonPrimary>
              </Link>

              <ButtonOutline
                onClick={onCloseBanned}
                data-testid="buttonClose_accountBanned"
                width="100%"
              >
                Tutup
              </ButtonOutline>
            </Box>
          </Modal>
        </Layout>
      )}
    </>
  );
};

export default HomePage;
